import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import * as wizard from "./wizard";
import { wizardState, wizardGetters, wizardMutations, wizardActions } from "./wizard";

const store = new Vuex.Store({
    state: {
        ...wizardState
    },
    getters: {
        ...wizardGetters
    },
    mutations: {
        ...wizardMutations
    },
    actions: {
        ...wizardActions
    }
});

export default store;
